module.exports = {

    init()
    {
        $(this.onDOMLoad.bind(this));
    },

    onDOMLoad()
    {
        this.initSelect2();
    },

    initSelect2(baseElement)
    {
        $('select.select2', baseElement)
            .each(function()
            {
                var options = {};

                // Init default html template?
                if($(this).find('option[data-html]').length)
                    options.templateResult = options.templateSelection = function(state)
                    {
                        var html = $(state.element).data('html');

                        return html ? $('<div />').html(html) : $('<div />').text(state.text);
                    };

                // Init select2.
                $(this).select2(options);
            });
    }

};
